/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["se"] = {
    wikiLinkLabel:  "Discuss"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/se/timeline.js
// module id = 593
// module chunks = 3